// Texts and languages (contract section 6).
/** @typedef {import('./typedefs.js').Translatable} Translatable */

const present = (v) => typeof v === 'string' && v !== '';

/**
 * The text of a translatable field in one language.
 * Order: the asked language, then each of `fallbacks` (pass the map's `lang.default`), then `en`, then the first
 * text present, then the empty string. A regional tag falls back to its base (`fi-FI` to `fi`). A plain string is
 * the map's default language and is returned as it is. A key name is never returned.
 * @param {Translatable | null | undefined} field
 * @param {string} [lang]
 * @param {string | string[]} [fallbacks]
 * @returns {string}
 */
export function t(field, lang, fallbacks) {
  if (typeof field === 'string') return field;
  if (!field || typeof field !== 'object' || Array.isArray(field)) return '';
  const order = [lang, ...(Array.isArray(fallbacks) ? fallbacks : [fallbacks]), 'en'];
  for (const tag of order) {
    if (typeof tag !== 'string' || !tag || tag === '_auto') continue;
    if (present(field[tag])) return field[tag];
    const base = tag.split('-')[0];
    if (base !== tag && present(field[base])) return field[base];
  }
  for (const [tag, v] of Object.entries(field)) if (tag !== '_auto' && present(v)) return v;
  return '';
}
